module.exports = __webpack_public_path__ + "static/media/1.da80a8e9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/1.gif
// module id = 64
// module chunks = 0